import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_COLLEGIATE_DUNGEON_RACE_DATA,
  SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD,
  SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD_FILTER,
  SET_COLLEGIATE_DUNGEON_RACE_SUMMARY,
  SHOW_LOADING_SPINNER
} from '../actions/collegiateDungeonRaceActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

const leaderboardDefaultFilters = {
  dungeon: 'all',
  affixes: 'all',
  region: 'world'
};

export default function collegiateDungeonRaceReducer(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_COLLEGIATE_DUNGEON_RACE_DATA: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SET_COLLEGIATE_DUNGEON_RACE_SUMMARY: {
      return {
        ...state,
        tournamentSummary: action.payload
      };
    }
    case SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD: {
      return {
        ...state,
        leaderboard: action.payload,
        leaderboardFilter: {
          ...leaderboardDefaultFilters,
          ...action.payload.ui
        }
      };
    }
    case SET_COLLEGIATE_DUNGEON_RACE_LEADERBOARD_FILTER: {
      return {
        ...state,
        leaderboardFilter: {
          ...leaderboardDefaultFilters,
          ...action.payload
        }
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default: {
      return state;
    }
  }
}
